import React, { createContext, useContext, useState, useCallback, useRef } from 'react';


export interface CustomBreadcrumbItem {
  label: string;
}

interface BreadcrumbContextValue {
  customBreadcrumbs: CustomBreadcrumbItem[];
  setCustomBreadcrumbs: (items: CustomBreadcrumbItem[]) => void;
  onBreadcrumbClick: (index: number) => void;
  setOnBreadcrumbClick: (handler: (index: number) => void) => void;
  lastSegmentLabel: string | null;
  setLastSegmentLabel: (label: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue | undefined>(undefined);

export function BreadcrumbProvider({ children }: { children: React.ReactNode }) {
  const [customBreadcrumbs, setCustomBreadcrumbs] = useState<CustomBreadcrumbItem[]>([]);
  const [lastSegmentLabel, setLastSegmentLabel] = useState<string | null>(null);
  const clickHandlerRef = useRef<(index: number) => void>(() => {});

  const onBreadcrumbClick = useCallback((index: number) => {
    clickHandlerRef.current(index);
  }, []);

  const setOnBreadcrumbClick = useCallback((handler: (index: number) => void) => {
    clickHandlerRef.current = handler;
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ customBreadcrumbs, setCustomBreadcrumbs, onBreadcrumbClick, setOnBreadcrumbClick, lastSegmentLabel, setLastSegmentLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbContext() {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumbContext must be used within a BreadcrumbProvider');
  }
  return context;
}
